import Add20 from '@carbon/icons-react/es/add/20';
import {
  faBallot,
  faClipboardList,
  faFile,
  faProjectDiagram,
} from '@fortawesome/pro-duotone-svg-icons';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import {
  EmptyState,
  EmptyStateContainer,
  EmptyStateIcon,
} from 'components/atoms/empty-state';
import { TemplateObjectType } from 'data/templates/api';
import { TranslationKey } from 'hooks/use-translation';

const StyledLink = styled(Link)`
  color: white;
`;

export const TemplateEmptyState: FC<{
  route: string;
  translationKey: TranslationKey;
  objectType: TemplateObjectType;
  onCreateNew?: () => void;
}> = ({ route, translationKey, objectType, onCreateNew }) => {
  const emptyStateIcon = [
    {
      type: TemplateObjectType.Project,
      icon: faProjectDiagram,
      title: <FormattedMessage id="template.empty_state.project.title" />,
      message: <FormattedMessage id="template.empty_state.project.message" />,
    },
    {
      type: TemplateObjectType.Document,
      icon: faFile,
      title: <FormattedMessage id="template.empty_state.document.title" />,
      message: <FormattedMessage id="template.empty_state.document.message" />,
    },
    {
      type: TemplateObjectType.StatusUpdates,
      icon: faClipboardList,
      title: <FormattedMessage id="template.empty_state.status_update.title" />,
      message: (
        <FormattedMessage id="template.empty_state.status_update.message" />
      ),
    },
    {
      type: TemplateObjectType.Form,
      icon: faBallot,
      title: <FormattedMessage id="template.empty_state.form.title" />,
      message: <FormattedMessage id="template.empty_state.form.message" />,
    },
  ];

  const templateState = emptyStateIcon.find(
    (templateType) => templateType.type === objectType,
  );

  return (
    <EmptyStateContainer $transparent>
      <EmptyState
        image={<EmptyStateIcon icon={templateState?.icon} />}
        title={templateState?.title}
        message={templateState?.message}
        primaryCTA={
          <StyledLink to={`${route}/new`} onClick={onCreateNew}>
            <EmptyState.CallToAction.Primary icon={<Add20 />}>
              <FormattedMessage id={`${translationKey}.create`} />
            </EmptyState.CallToAction.Primary>
          </StyledLink>
        }
      />
    </EmptyStateContainer>
  );
};
